/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Psychology14Inputs */

const en__field_enum_tuda_psychology14 = /** @type {(inputs: _Field_Enum_Tuda_Psychology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychology`)
};

const de__field_enum_tuda_psychology14 = /** @type {(inputs: _Field_Enum_Tuda_Psychology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Psychologie`)
};

/**
* | output |
* | --- |
* | "Psychology" |
*
* @param {_Field_Enum_Tuda_Psychology14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_psychology14 = /** @type {((inputs?: _Field_Enum_Tuda_Psychology14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Psychology14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_psychology14(inputs)
	return de__field_enum_tuda_psychology14(inputs)
});
export { _field_enum_tuda_psychology14 as "_field_enum_TUDA_PSYCHOLOGY" }